import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FadeUp } from "@/components/site/Reveal";
import { MEDIA } from "@/lib/assets";

export const Team = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section id="team" ref={ref} data-testid="team-section" className="bg-background py-28 md:py-40 border-t border-border">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-4">
            <FadeUp>
              <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-primary mb-6">/ Team Paptech</p>
              <h2 className="font-display text-5xl md:text-7xl leading-[0.95]">
                The people<br /> behind the paper.
              </h2>
              <p className="text-muted-foreground mt-8 leading-relaxed">
                From the trade desk to the sheet-cutting floor, a hands-on team keeps every order moving — sourcing,
                grading, cutting and delivering with the reliability our partners have come to expect.
              </p>
              <div className="mt-10 grid grid-cols-2 gap-6">
                <div className="border-t border-foreground pt-4">
                  <p className="font-display text-4xl text-primary">20+</p>
                  <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-1">Team members</p>
                </div>
                <div className="border-t border-foreground pt-4">
                  <p className="font-display text-4xl text-primary">2</p>
                  <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-1">West-zone hubs</p>
                </div>
              </div>
            </FadeUp>
          </div>

          <div className="lg:col-span-8">
            <FadeUp delay={0.15}>
              <div className="overflow-hidden border border-border">
                <motion.img
                  style={{ y, scale: 1.08 }}
                  src={MEDIA.team}
                  alt="Team Paptech"
                  className="w-full h-[420px] md:h-[560px] object-cover"
                />
              </div>
            </FadeUp>
          </div>
        </div>
      </div>
    </section>
  );
};
